import React, { useState } from 'react';
import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import MainProductsComponent from "../../components/product/mainProductsHome/mainProductsComponent";

export default function MainProductPage(props) {

    return (
        <div>

            <NavBarComponent />
            <MainProductsComponent />
            <FooterComponent />
        </div>
    );
};

